export default __webpack_public_path__ + "static/media/bc.3197053f.webp";